import eventBus from '@/utils/event-bus.ts';
import { generateUuid } from '@/utils/generate-uuid.ts';
// import { ProgressQuestion } from 'mdue';
import { type Ref, ref } from 'vue';

interface PopupStackEntry {
  type: 'confirm' | 'alert' | 'prompt';
  title: string;
  body: string;
  okButtonText: string;
  okButtonClasses?: string;
  cancelButtonText: string;
  id: string;
  blocksNavigation: boolean;
  /** Icons from icones.js.org */
  iconName: string;
  iconClasses: string;
  inputPlaceholder: string;
  inputType: 'text' | 'number' | 'password' | 'email' | 'tel' | 'url' | 'search' | 'date' | 'time' | 'datetime-local' | 'month' | 'week' | 'color' | 'textarea';
}

export const popupStack: Ref<PopupStackEntry[]> = ref([]);

type ConfirmParams = Partial<Omit<PopupStackEntry, 'id' | 'type' | 'inputPlaceholder'>>;

export function showConfirm(options: ConfirmParams) {
  const defaults = {
    title: 'Missing title',
    body: 'Missing body',
    okButtonText: 'Missing okButtonText',
    okButtonClasses: 'btn-primary',
    cancelButtonText: 'Missing cancelButtonText',
  };
  const id = generateUuid();
  const stackItem = {
    ...defaults,
    ...options,
    id,
    type: 'confirm',
    blocksNavigation: true,
  } as PopupStackEntry;
  return displayPopup(stackItem) as Promise<boolean>;
}

type PromptParams = Partial<Omit<PopupStackEntry, 'id' | 'type'>>;

export function showPrompt(options: PromptParams): Promise<string | null> {
  const defaults = {
    okButtonText: 'Missing okButtonText',
    cancelButtonText: 'Missing cancelButtonText',
    // iconComponent: markRaw(ProgressQuestion),
    iconSize: '2.5rem',
    iconColor: 'inherit',
  };
  const id = generateUuid();
  const stackItem = {
    ...defaults,
    ...options,
    id,
    type: 'prompt',
    blocksNavigation: true,
  } as PopupStackEntry;
  return displayPopup<string | null>(stackItem);
}

type AlertParams = Partial<Omit<PopupStackEntry, 'id' | 'type' | 'cancelButtonText' | 'inputPlaceholder'>>;

export function showAlert(options: AlertParams) {
  const defaults = {
    title: '',
    body: '',
    okButtonText: 'Missing okButtonText',
    cancelButtonText: '',
  };
  const id = generateUuid();
  const stackItem = {
    ...defaults,
    ...options,
    id,
    type: 'alert',
    blocksNavigation: true,
  } as PopupStackEntry;
  return displayPopup(stackItem);
}

function displayPopup<T>(stackItem: PopupStackEntry) {
  popupStack.value.push(stackItem);
  return new Promise<T>((resolve) => {
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    eventBus.once(stackItem.id, (args: any) => {
      const index = popupStack.value.findIndex((x) => x.id === stackItem.id);
      popupStack.value.splice(index, 1);
      resolve(args);
    });
  });
}
